var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"text-left",attrs:{"border":"left","colored-border":"","color":"#c80404","elevation":"2"}},[_c('h3',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }